// 公募基金累计收益
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import Model, { valueWithArray } from 'ducker-model';
import chartTool from '../utils/chart';

// 收益点
const pointProperty = {
  date: String,
  value: String,
  type: String,
};

const navKeyFromPropertyName = {
  date: 'PDATE',
  value: {
    property: 'NAV',
    defaultValue: null,
    computed: (value) => (isEmpty(value) ? null : parseFloat(value)),
  },
  type: {
    defaultValue: 'nav-point',
  },
};

const NAVModel = new Model(pointProperty, navKeyFromPropertyName);

const NAVCHGRT100KeyFromPropertyName = {
  date: 'PDATE',
  value: {
    property: 'NAVCHGRT100',
    defaultValue: null,
    computed: (value) => (isEmpty(value) ? null : parseFloat(value)),
  },
  type: {
    defaultValue: 'navchgrt100-point',
  },
};

const NAVCHGRT100Model = new Model(pointProperty, NAVCHGRT100KeyFromPropertyName);

const MUIKeyFromPropertyName = {
  date: 'PDATE',
  value: {
    property: 'MUI',
    defaultValue: null,
    computed: (value) => (isEmpty(value) ? null : parseFloat(value)),
  },
  type: {
    defaultValue: 'mui-point',
  },
};

const MUIModel = new Model(pointProperty, MUIKeyFromPropertyName);

const SYIKeyFromPropertyName = {
  date: 'PDATE',
  value: {
    property: 'SYI',
    defaultValue: null,
    computed: (value) => (isEmpty(value) ? null : parseFloat(value)),
  },
  type: {
    defaultValue: 'syi-point',
  },
};

const SYIModel = new Model(pointProperty, SYIKeyFromPropertyName);

// Model
const property = {
  navPointList: valueWithArray(Object),
  navRisePointList: valueWithArray(Object),
  muiPointList: valueWithArray(Object),
  syiPointList: valueWithArray(Object),
  extraInfo: Object,
};

const replacedKeyFromPropertyName = {
  navPointList: {
    property: 'data',
    computed: (data) => NAVModel.objectArrayWithKeyValuesArray(data),
  },
  navRisePointList: {
    property: 'data',
    computed: (data) => NAVCHGRT100Model.objectArrayWithKeyValuesArray(data),
  },
  muiPointList: {
    property: 'data',
    computed: (data) => MUIModel.objectArrayWithKeyValuesArray(data),
  },
  syiPointList: {
    property: 'data',
    computed: (data) => SYIModel.objectArrayWithKeyValuesArray(data),
  },
  extraInfo: {
    property: 'expansion',
    computed: (expansion) => {
      const aboutAccResponses = expansion?.aboutAcc || []; // 额外数据
      const changeInfo = expansion?.changeInfo || [];
      const maxReturn = expansion?.MAXRETRA || '';
      return {
        indexInfo: aboutAccResponses?.[aboutAccResponses.length - 1] || {},
        changePoints: chartTool.handleChangeInfo(changeInfo),
        maxReturn: chartTool.handleChartMaxReturn(changeInfo, maxReturn),
      };
    },
  },
};

export default new Model(property, replacedKeyFromPropertyName);
